// import $ from 'jquery';
//Import Swiper assets
import Swiper from "swiper/bundle";

import "../styles/style.scss";

// gsap.registerPlugin(ScrollTrigger);

// /*
// Add any JavaScript for your template
// */
// $(window).on("acf/loaded/container-swiper-wrapper", () => {
// 	initGsapScroller('.interface-interface-skeleton__content');
// });

// window.addEventListener("DOMContentLoaded", () => {
// 	if ($('#editor').length === 0) {
// 		initGsapScroller();
// 	}
// });

// function initGsapScroller(scrollerTarget = window) {
// };

// Initialize Swiper
function initSwiper() {
  const swiperContainers = document.querySelectorAll('.wp-block-acf-container-swiper-wrapper .swiper');
  
  swiperContainers.forEach((container) => {
    const swiper = new Swiper(container, {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      // Auto play (optional)
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      
      // Enable lazy loading
      lazy: {
        loadPrevNext: true,
      },
    });
  });
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  initSwiper();
});

// Initialize for ACF preview mode
if (typeof window.jQuery !== 'undefined') {
  window.jQuery(window).on('acf/loaded/container-swiper-wrapper', () => {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      initSwiper();
    }, 100);
  });
}
